import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Box from '@mui/material/Box';
import { useStacklineTheme } from '@stackline/ui';
// TODO: We have to refactor this constant to be a part of the theme
import { BEACON_PRO_PAGE_MARGIN_BOTTOM } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { SxProps } from '@mui/system';

interface BasePageContainerProps {
  sx?: SxProps;
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  sidebarContainerSx?: SxProps;
}
export default function BasePageContainer({ sx = {}, children, sidebar, sidebarContainerSx }: BasePageContainerProps) {
  const theme = useStacklineTheme();
  const [ready, setReady] = useState(false);

  /**
   * We create a portal for the sidebar and we use this to only create
   * the portal after the component is mounted so that the portal element
   * is available in the DOM.
   */
  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <Box marginTop={theme.spacing.lg} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM} position="relative" sx={{ ...sx }}>
      {ready &&
        sidebar &&
        createPortal(
          <Box
            id="rendered-portal"
            sx={{
              paddingBottom: BEACON_PRO_PAGE_MARGIN_BOTTOM,
              ...sidebarContainerSx
            }}
          >
            {sidebar}
          </Box>,
          document.getElementById('sidebar-portal')
        )}
      {children}
    </Box>
  );
}
